var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "forward-dialog",
      attrs: {
        width: "500px",
        title: "Select Recipient",
        visible: _vm.forwardDialogVisible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.forwardDialogVisible = $event
        },
        closed: _vm.onClosed,
        open: _vm.onOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-wrap" },
        [
          _c(
            "el-scrollbar",
            { staticClass: "custom" },
            [
              _c(
                "el-form",
                {
                  ref: "forwardForm",
                  attrs: {
                    model: _vm.forwardForm,
                    "label-position": "top",
                    rules: _vm.forwardFormRules,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "forwardTo", label: "Receiver" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "forwardToSelect",
                              attrs: {
                                placeholder: "Please enter the recipient",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.forwardForm.forwardTo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.forwardForm, "forwardTo", $$v)
                                },
                                expression: "forwardForm.forwardTo",
                              },
                            },
                            _vm._l(_vm.forwardList, function (itemML) {
                              return _c("el-option", {
                                key: itemML.UserID,
                                staticStyle: { "text-align": "left" },
                                attrs: {
                                  label: itemML.Name + "(" + itemML.Email + ")",
                                  value: itemML.LoginName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Comments", prop: "comment" } },
                        [
                          _c("el-input", {
                            attrs: {
                              autosize: { minRows: 6 },
                              readonly: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.forwardForm.comment,
                              callback: function ($$v) {
                                _vm.$set(_vm.forwardForm, "comment", $$v)
                              },
                              expression: "forwardForm.comment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(" Confirm ")]
          ),
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.onClosed } },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }